import { Outlet } from "react-router-dom";
import Storage from "../../utils/storage";
//import DeleteIcon from "@mui/icons-material/Delete";
import { useSelector } from "react-redux";
import {
  Backdrop,
  Box,
  Card,
  CircularProgress,
  //IconButton,
  //Tooltip,
} from "@mui/material";

export const PublicLayout = () => {
  const handleResetCache = (e) => {
    Storage.remove("persist:root");
  };
  const isLoading = useSelector((state) => {
    return (
      state.login.isLoading ||
      state.registration.isLoading ||
      state.forgotPassword.isLoading
    );
  });

  return (
    <div
      id="external"
      className="h-full w-full p-2 custom-background flex justify-center items-center"
    >
      <Box className="xl:w-[50%] lg:w-[65%] md:w-[80%] sm:w-[95%] w-[100%] my-auto">
        <Card
          className="border-0"
          style={{ backgroundColor: "rgba(255, 255, 255, 0.5)" }}
          sx={{ position: "relative" }}
        >
          {/*                     <Tooltip title="Reset Cache">
                        <IconButton onClick={handleResetCache}>
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip> */}
          <Outlet></Outlet>
          <Backdrop
            className="bg-black bg-opacity-30"
            sx={{ position: "absolute", zIndex: 1 }}
            open={isLoading}
          >
            <CircularProgress className="text-primary" />
          </Backdrop>
        </Card>
      </Box>
    </div>
  );
};
